<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0">
        <span @click="$router.go(-1)">
          <b-button
            variant="white"
            class="btn-icon rounded-circle mr-50 text-primary bg-white"
            size="sm"
          >
            <feather-icon icon="ChevronLeftIcon" />
          </b-button>
        </span>
        Configuración de vacaciones
      </h2>
    </div>
    <b-card>
      <div class="mb-2">
        <p class="text-muted small">Aquí puedes gestionar los parámetros de vacaciones anuales, acumulables y otras opciones relacionadas con el cliente actual.</p>
      </div>
      <b-row>
        <b-col sm="4">
          <b-form-group label="Días acumulables al acabar el año">
            <b-form-checkbox v-model="accumulable_days" switch :value="1" :unchecked-value="0" />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Días vacaciones anuales">
            <b-form-input v-model="annual_vacation_days" type="number" placeholder="Días vacaciones anuales" />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Tipo de días de vacaciones">
            <b-form-select v-model="vacation_days_type" :options="vacationDaysTypeOptions" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button variant="primary" @click="guardarConfiguracion">Guardar</b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { BButton, BRow, BCol, BCard, BFormGroup, BFormCheckbox, BFormInput, BFormSelect } from 'bootstrap-vue'
export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormCheckbox,
    BFormInput,
    BFormSelect,
  },
  data() {
    return {
      accumulable_days: false,
      annual_vacation_days: 0,
      vacation_days_type: '',
      vacationDaysTypeOptions: [
        { value: 'laboral', text: 'Días laborables' },
        { value: 'natural', text: 'Días naturales' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      currentClient: 'clients/getCurrentClient',
      calendar: 'calendar/getConfigCalendar',
    }),
  },
  methods: {
    ...mapActions({
      getCalendar: 'calendar/getConfigCalendar',
      editCalendar: 'calendar/edit',
    }),
    setData() {
      this.accumulable_days = this.calendar.accumulable_days || 0
      this.annual_vacation_days = this.calendar.annual_vacation_days || 0
      this.vacation_days_type = this.calendar.vacation_days_type || ''
    },
    async guardarConfiguracion() {
      const data = new FormData()
      data.append('accumulable_days', this.accumulable_days)
      data.append('annual_vacation_days', this.annual_vacation_days)
      data.append('vacation_days_type', this.vacation_days_type)
      data.append('client_id', this.currentClient.id)
      await this.editCalendar({ calendar: data })
    },
  },
  async mounted() {
    await this.getCalendar(this.currentClient.id)
    this.setData()
  },
}
</script>

<style scoped>
</style>
